const banks = [
  {
    panId: 627381,
    ibanId: '063',
    vectorName: 'ansar',
    name: 'بانک انصار'
  },
  {
    panId: 636214,
    ibanId: '062',
    vectorName: 'ayandeh',
    name: 'بانک آینده'
  },
  {
    panId: 502938,
    ibanId: '066',
    vectorName: 'dey',
    name: 'بانک دی'
  },
  {
    panId: 627412,
    ibanId: '055',
    vectorName: 'eghtesadNovin',
    name: 'بانک اقتصادنوین'
  },
  {
    panId: 628157,
    ibanId: '051',
    vectorName: 'etebariTosee',
    name: 'موسسه اعتباری توسعه'
  },
  {
    panId: 505416,
    ibanId: '064',
    vectorName: 'gardeshgari',
    name: 'بانک گردشگری'
  },
  {
    panId: 639599,
    ibanId: '0??',
    vectorName: 'ghavvamin',
    name: 'بانک قوامین'
  },
  {
    panId: 505785,
    ibanId: '069',
    vectorName: 'iranZamin',
    name: 'بانک ایران زمین'
  },
  {
    panId: 627488,
    ibanId: '053',
    vectorName: 'karafarin',
    name: 'بانک کارآفرین'
  },
  {
    panId: 502910,
    ibanId: '053',
    vectorName: 'karafarin',
    name: 'بانک کارآفرین'
  },
  {
    panId: 603770,
    ibanId: '016',
    vectorName: 'keshavarzi',
    name: 'بانک کشاورزی'
  },
  {
    panId: 639217,
    ibanId: '016',
    vectorName: 'keshavarzi',
    name: 'بانک کشاورزی'
  },
  {
    panId: 628023,
    ibanId: '014',
    vectorName: 'maskan',
    name: 'بانک مسکن'
  },
  {
    panId: 639370,
    ibanId: '0??',
    vectorName: 'mehrEghtesad',
    name: 'بانک مهر اقتصاد'
  },
  {
    panId: 606373,
    ibanId: '060',
    vectorName: 'mehrIran',
    name: 'بانک قرض الحسنه مهر ایرانیان'
  },
  {
    panId: 603799,
    ibanId: '017',
    vectorName: 'melli',
    name: 'بانک ملی ایران'
  },
  {
    panId: 610433,
    ibanId: '012',
    vectorName: 'mellat',
    name: 'بانک ملت'
  },
  {
    panId: 991975,
    ibanId: '012',
    vectorName: 'mellat',
    name: 'بانک ملت'
  },
  {
    panId: 622106,
    ibanId: '054',
    vectorName: 'parsian',
    name: 'بانک پارسیان'
  },
  {
    panId: 502229,
    ibanId: '057',
    vectorName: 'pasargad',
    name: 'بانک پاسارگاد'
  },
  {
    panId: 639347,
    ibanId: '057',
    vectorName: 'pasargad',
    name: 'بانک پاسارگاد'
  },
  {
    panId: 627760,
    ibanId: '021',
    vectorName: 'postBank',
    name: 'پست بانک ایران'
  },
  {
    panId: 589463,
    ibanId: '013',
    vectorName: 'refahKargaran',
    name: 'بانک رفاه'
  },
  {
    panId: 627961,
    ibanId: '011',
    vectorName: 'sanatMadan',
    name: 'بانک صنعت و معدن'
  },
  {
    panId: 603769,
    ibanId: '019',
    vectorName: 'saderat',
    name: 'بانک صادرات'
  },
  {
    panId: 621986,
    ibanId: '056',
    vectorName: 'saman',
    name: 'بانک سامان'
  },
  {
    panId: 639607,
    ibanId: '058',
    vectorName: 'sarmayeh',
    name: 'بانک سرمایه'
  },
  {
    panId: 589210,
    ibanId: '015',
    vectorName: 'sepah',
    name: 'بانک سپه'
  },
  {
    panId: 504706,
    ibanId: '061',
    vectorName: 'shahr',
    name: 'بانک شهر'
  },
  {
    panId: 502806,
    ibanId: '061',
    vectorName: 'shahr',
    name: 'بانک شهر'
  },
  {
    panId: 639346,
    ibanId: '059',
    vectorName: 'sina',
    name: 'بانک سینا'
  },
  {
    panId: 627353,
    ibanId: '018',
    vectorName: 'tejarat',
    name: 'بانک تجارت'
  },
  {
    panId: 585983,
    ibanId: '018',
    vectorName: 'tejarat',
    name: 'بانک تجارت'
  },
  {
    panId: 636949,
    ibanId: '065',
    vectorName: 'hekmat',
    name: 'بانک حکمت'
  },
  {
    panId: 627648,
    ibanId: '020',
    vectorName: 'toseSaderat',
    name: 'بانک توسعه صادرات'
  },
  {
    panId: 502908,
    ibanId: '022',
    vectorName: 'toseTaavon',
    name: 'بانک توسعه تعاون'
  }
] as const;

export function getBankInfo(
  name?: (typeof banks)[number]['name'],
  panId?: number | string,
  ibanId?: number | string
) {
  const property = name || panId || ibanId;
  if (property === undefined) {
    throw Error(
      "At least one of 'name', 'panId', or 'ibanId' pramaters must be provided."
    );
  }

  if (name) {
    for (const bank of banks)
      if (bank.name === name) {
        return bank;
      }
  } else if (panId) {
    const _panId = String(panId);
    for (const bank of banks)
      if (_panId.startsWith(String(bank.panId))) {
        return bank;
      }
  } else if (ibanId) {
    for (const bank of banks)
      if (new RegExp(`(?:IR)?\\d{2}${bank.ibanId}`, 'i').test(String(ibanId))) {
        return bank;
      }
  }
}
